import { render, staticRenderFns } from "./DeleteHosting.vue?vue&type=template&id=b30ffb22&"
import script from "./DeleteHosting.vue?vue&type=script&lang=js&"
export * from "./DeleteHosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports